var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#006633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2146 20.3454C31.1434 21.1739 28.9251 21.7131 26.6093 21.913C25.9418 21.9705 25.2661 22 24.5834 22H23.8334C20.9339 22 18.5834 24.3505 18.5834 27.25C18.5834 29.8496 20.4728 32.0079 22.9533 32.4265C23.2876 33.7955 23.7514 35.1137 24.331 36.3674C24.7951 37.3711 26.0052 37.6874 26.9137 37.1629L27.57 36.784C28.4501 36.2759 28.7356 35.1913 28.3421 34.3158C28.1072 33.7935 27.8976 33.2573 27.7148 32.7089C29.6322 32.967 31.4752 33.4587 33.2146 34.1545C33.9403 31.9852 34.3334 29.6635 34.3334 27.2499C34.3334 24.8364 33.9403 22.5147 33.2146 20.3454Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.594 19.7407C35.3975 22.0964 35.8334 24.6222 35.8334 27.2499C35.8334 29.8776 35.3975 32.4035 34.594 34.7593C34.5388 34.921 34.4821 35.082 34.4235 35.2422C34.2811 35.6311 34.481 36.0619 34.87 36.2043C35.259 36.3466 35.6897 36.1467 35.8321 35.7578C35.9721 35.3753 36.103 34.9883 36.2244 34.5972C36.748 32.9105 37.0961 31.1468 37.2474 29.3277C37.7643 28.7893 38.0834 28.0566 38.0834 27.25C38.0834 26.4433 37.7643 25.7107 37.2474 25.1722C37.0961 23.3531 36.748 21.5894 36.2244 19.9027C36.103 19.5116 35.9721 19.1247 35.8321 18.7422C35.6897 18.3532 35.259 18.1533 34.87 18.2957C34.481 18.438 34.2811 18.8688 34.4235 19.2578C34.4821 19.4179 34.5388 19.5789 34.594 19.7407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.81321489bd45e3fef9d94d1ed79118d7.svg";
export { ForwardRef as ReactComponent };